export default __webpack_public_path__ + "static/media/mumbai.177c3400.png";